import classNames from "classnames";
import { AlertStyle } from "../../js/enums";

function Alert({
  children,
  className = "my-3",
  style = AlertStyle.Danger,
  title,
  text,
}) {
  return (
    <div
      className={classNames("alert", style, className)}
      role="alert"
    >
      {title && (
        <p>
          <strong>{title}</strong>
        </p>
      )}
      {children ? (
        children
      ) : (
        <p className="mb-0">{text}</p>
      )}
    </div>
  );
}

export default Alert;
